import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";
import config from "@client/config";

const getAnnounmentOnlyList = () => {
  return responseFormatter(
    http.get(`/extensions?extTypes=Announcement`, {
      setAuthHeader: true,
    })
  );
};

const getPhoneNumberList = (extensionId) => {
   return responseFormatter(
     http.get(`/extensions/${extensionId}/phone-number`, {
       setAuthHeader: true,
     })
   );
 };

 const getAnsweringRule = (extensionId) => {
   return responseFormatter.rc(
     http.rc.get(`/account/~/extension/${extensionId}/answering-rule?view=Detailed&enabledOnly=false&page=1&perPage=1000`, {
       setAuthHeader: true,
     })
   );
 };

 const getGreeting = (extensionId, greetingId) => {
    return responseFormatter.rc(
      http.rc.get(`/account/~/extension/${extensionId}/greeting/${greetingId}`, {
        setAuthHeader: true,
      })
    );
  };

const uploadGreeting = (extensionId, payload = {}) => {
  return responseFormatter(
    http.post(`/extensions/${extensionId}/upload-greeting`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      setAuthHeader: true,
    })
  );
};

const getTimestamp = () => {
  return responseFormatter(
    http.get(`/timestamp`, {
      setAuthHeader: true,
    })
  );
};

const makeRingoutCall = async (fromNumber, toNumber = config.voicemailNumber, accountUid = "~", extensionId = "~") => {
  const payload = {
    "from": {"phoneNumber": fromNumber},
    "to": {"phoneNumber": toNumber},
  };
  return responseFormatter.rc(
    http.rc.post(`/account/${accountUid}/extension/${extensionId}/ring-out`, payload, {
      setAuthHeader: true,
    })
  );
};

const uploadVoicemail = async (payload = {}) => {
  return await responseFormatter(
    http.post(`/upload-voicemail`, payload, {
      setAuthHeader: true
    })
  );
};

const getRingoutCallStatus = async (rignoutId, accountUid = "~", extensionId = "~") => {
  return responseFormatter.rc(
    http.rc.get(`/account/${accountUid}/extension/${extensionId}/ring-out/${rignoutId}`, {
      setAuthHeader: true,
    })
  );
};

const cancelRingout = async (ringoutId, accountUid = "~", extensionId = "~") => {
  return responseFormatter.rc(
    http.rc.delete(`/account/${accountUid}/extension/${extensionId}/ring-out/${ringoutId}`, {
      setAuthHeader: true,
    })
  );
};

const parsePhoneNumber = payload => {
  return responseFormatter.rc(
    http.rc.post(`/number-parser/parse`, payload, {
      setAuthHeader: true,
    })
  );
};

const Service = {
  getAnnounmentOnlyList,
  getPhoneNumberList,
  getAnsweringRule,
  getGreeting,
  uploadGreeting,
  getTimestamp,
  makeRingoutCall,
  cancelRingout,
  uploadVoicemail,
  getRingoutCallStatus,
  parsePhoneNumber
};

export default Service;
